<template>
  <ElementLayout>
    <!-- @vue-ignore -->
    <template #element>
      <!-- @vue-ignore -->
      <template v-if="typeof (items || [])[0] === 'string'">
        <!-- @vue-ignore -->
        <v-combobox
          v-model="selection"
          v-model:search="search"
          density="compact"
          class="vueform-combobox"
          ref="customCombobox"
          :items="items"
          hide-details
          @blur="onBlur"
        >
          <template v-slot:item="{ props, item }">
            <v-list-item
              v-bind="props"
              @click="() => {
                // @ts-ignore
                clickOption(item.value)
              }"
            ></v-list-item>
          </template>
        </v-combobox>
      </template>
      <!-- @vue-ignore -->
      <template v-else>
        <!-- @vue-ignore -->
        <v-combobox
          v-model="selection"
          v-model:search="search"
          density="compact"
          class="vueform-combobox"
          ref="customCombobox"
          :items="items"
          item-value="value"
          item-title="label"
          :custom-filter="customFilter"
          hide-details
          @blur="onBlur"
        >
          <template v-slot:item="{ props, item }">
            <v-list-item
              v-bind="props"
              @click="() => {
                // @ts-ignore
                clickOption(item.raw)
              }"
            ></v-list-item>
          </template>
        </v-combobox>
       </template>
    </template>
  </ElementLayout>
</template>

<script lang="ts">
import { defineElement } from '@vueform/vueform'
import { customAccountabilityFilter } from '@/utils/accountability_filters'

interface ObjectItem {
  value: string
  label: string,
  code?: string
}
interface Element {
  value: string | ObjectItem
  update: Function
}
interface Attrs {
  items: string[] | ObjectItem[]
}
interface Context {
  element: Element
  attrs: Attrs
}

export default defineElement({
  name: 'CustomSelectElement',
  setup(props: Object, { element, attrs }: Context) {
    const { value, update } = element
    const { items } = attrs
    const clickOption = (item: string | ObjectItem) => update(item)
    return { value, items, update, clickOption }
  },
  data() {
    return {
      search: "",
      selection: this.value as string | ObjectItem | null
    }
  },
  methods: {
    onBlur() {
      // @ts-ignore
      if (typeof this.items[0] === 'string') {
        // @ts-ignore
        if (!this.items.includes(this.value)) {
          // @ts-ignore
          this.search = ''
          // @ts-ignore
          this.$refs.customCombobox.search = ""
          // @ts-ignore
          this.update(null)
        }
      } else {
        // @ts-ignore
        if (!this.items.map(item => item.label).includes(this.search)) {
          // @ts-ignore
          this.search = ''
          // @ts-ignore
          this.$refs.customCombobox.search = ""
          // @ts-ignore
          this.update(null)
        }
      }
    },
    customFilter: customAccountabilityFilter,
  }
})
</script>
